import React from "react";

import { Code } from "@packages/ds";

import useDecodedParams from "Hooks/useDecodedParams";
import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import {
  deploymentSizingApiEnabledSelector,
  oneDeploymentResourceSelector,
  currentAppSelector
} from "Reducers/environment/deployment";
import AppInfos from "src/organization/common/components/AppInfos/AppInfos";
import Layout from "src/organization/pages/project/environment/services/components/Layout";
import Crons from "src/organization/pages/project/environment/services/overview/components/Crons";
import { useGetResourceType } from "src/organization/pages/project/environment/services/overview/components/hooks/useGetResourceType";
import RelationshipsApps from "src/organization/pages/project/environment/services/overview/components/RelationshipsApps";
import ServiceMetrics from "src/organization/pages/project/environment/services/overview/components/ServiceMetrics";
import Workers from "src/organization/pages/project/environment/services/overview/components/Workers";
import { useAppSelector } from "Store/hooks";

import SshHostList from "./SshHostList";
import * as S from "./styles";
import { useSshUrl } from "./useSshUrl";

const AppOverview = () => {
  const { organizationId, projectId, environmentId, appName } =
    useDecodedParams<{
      organizationId: string;
      projectId: string;
      environmentId: string;
      appName: string;
    }>();
  const currentApp = useSelectorWithUrlParams(currentAppSelector, {
    key: "webapps"
  });

  const ssh = useSshUrl();
  const isSizingApiEnabled = useSelectorWithUrlParams(
    deploymentSizingApiEnabledSelector
  );

  const resourceType = useGetResourceType();

  const currentResource = useAppSelector(state =>
    oneDeploymentResourceSelector(state, {
      organizationId,
      projectId,
      environmentId,
      resourceType,
      appName
    })
  );

  return (
    <>
      <Layout>
        <S.AppInfoRow>
          {currentApp?.metadata && (
            <AppInfos
              metadata={currentApp.metadata}
              isSizingApiEnabled={isSizingApiEnabled}
              isServicesTab={true}
              profileLabel={currentResource?.profileLabel}
              crons={currentResource?.crons}
            />
          )}
          <S.SshURLList className="ssh-code">
            {ssh && typeof ssh === "string" && (
              <Code.Block singleLine isCopyable id={ssh}>
                {ssh}
              </Code.Block>
            )}
            {ssh instanceof Array && ssh.length > 0 && (
              <SshHostList sshList={ssh} />
            )}
          </S.SshURLList>
        </S.AppInfoRow>
      </Layout>
      <ServiceMetrics serviceName={appName} />
      <Crons />
      <Workers />
      <RelationshipsApps />
    </>
  );
};

export default AppOverview;
